import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';

export default function PWAUpdateBanner() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    const onControllerChange = () => {
      if (!navigator.serviceWorker.controller) return;
      // A new SW has taken control — a new version is now active
      setReady(true);
    };

    navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);
    return () => navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
  }, []);

  if (!ready) return null;

  return (
    <div className="fixed bottom-20 md:bottom-4 left-1/2 -translate-x-1/2 z-[200] flex items-center gap-3 px-4 py-2.5 rounded-2xl bg-gray-900/95 border border-white/10 shadow-2xl backdrop-blur-sm text-sm font-semibold text-white whitespace-nowrap">
      <RefreshCw className="w-4 h-4 text-emerald-400 flex-shrink-0" />
      <span>Yeni sürüm mevcut</span>
      <button
        onClick={() => window.location.reload()}
        className="px-3 py-1 rounded-xl bg-emerald-500 hover:bg-emerald-400 text-white text-xs font-semibold transition-colors cursor-pointer flex-shrink-0"
      >
        Yenile
      </button>
    </div>
  );
}
